import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
	Wrapper,
	Textarea,
	Label,
	ErrorMsg,
} from './formStyles';

class StyledTextarea extends PureComponent {
	id = 'textarea-' + Math.floor(Math.random() * 100000)

	render () {
		const { placeholder, className, errorMsg, ...props } = this.props;
		const { id } = this;
		return (
			<Wrapper className={className} invalid={!!errorMsg}>
				<Textarea id={id} {...props} invalid={!!errorMsg} className={classNames({ "valid": !!props.value })} />
				<Label htmlFor={id} top>{placeholder}</Label>
				<ErrorMsg show={!!errorMsg}>{errorMsg}</ErrorMsg>
			</Wrapper>
		);
	}
}

StyledTextarea.propTypes = {
	placeholder: PropTypes.string.isRequired,
	className: PropTypes.string,
	errorMsg: PropTypes.string,
};

export default StyledTextarea;
